import React from "react";
import {FenceBodyLayout} from "../FenceBodyLayout/FenceBodyLayout";

const MapEmptyBodyLayout = ({toggleVisible, isVisible, itemId, itemType}): JSX.Element => <FenceBodyLayout isVisible={isVisible} toggleVisible={toggleVisible} needFencesTab={!itemId || !['device', 'person'].includes(itemType)} />;

export default MapEmptyBodyLayout;